import { useTranslation } from 'react-i18next';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../../db/local.js';

/**
 * Foto-Schätzung auf „Heute“ (28.10.2026): Solange ein Auftrag offen ist,
 * steht hier sein Stand — ein fertiger Vorschlag oder ein Fehlschlag ist
 * „jetzt dran“, ein Tipp führt in den Tag mit dem Platzhalter. Ohne Auftrag
 * erscheint nichts.
 */
export function TodayEstimates({ onOpen }: { onOpen: () => void }): React.JSX.Element | null {
  const { t } = useTranslation();
  const jobs = useLiveQuery(() => db.estimate_jobs.toArray(), []);
  if (!jobs || jobs.length === 0) return null;

  const ready = jobs.filter((job) => job.status === 'done').length;
  const failed = jobs.filter((job) => job.status === 'failed').length;
  const waiting = jobs.length - ready - failed;
  return (
    <section aria-labelledby="today-estimates" className="kw-tile flex flex-col gap-2">
      <h2 id="today-estimates" className="kw-kicker">
        {t('nutrition.day.photo.today.heading')}
      </h2>
      {ready > 0 ? (
        <p className="text-base font-semibold">
          {t('nutrition.day.photo.today.ready', { count: ready })}
        </p>
      ) : null}
      {failed > 0 ? (
        <p className="text-sm text-warn">
          {t('nutrition.day.photo.today.failed', { count: failed })}
        </p>
      ) : null}
      {waiting > 0 ? (
        <p className="text-sm text-ink-muted">
          {t('nutrition.day.photo.today.waiting', { count: waiting })}
        </p>
      ) : null}
      <button type="button" onClick={onOpen} className="kw-btn kw-btn-small">
        {t('nutrition.day.photo.today.open')}
      </button>
    </section>
  );
}
